import {
    HalfYearFilter,
    MonthYearRangeFilter,
    QuarterFilter,
    SingleMonthYearFilter,
    StatsFilters as StatsFiltersType,
    TIME_PERIOD_OPTIONS,
    TimePeriod, YearFilter,
} from '../../../../domain/statsFilters';

export const buildStatsFiltersFromSearchParams = (searchParams: URLSearchParams): StatsFiltersType => {
    const creatorId = searchParams.get('creatorId');
    const contractorId = searchParams.get('contractorId');
    const timePeriod = searchParams.get('timePeriod') as TimePeriod | undefined;

    const dateRangeFilters = getTimePeriodFilterWithProperFilters(timePeriod, searchParams);

    return {
        ...(creatorId ? { creator: { id: creatorId } } : {}),
        ...(contractorId ? { contractor: { id: contractorId } } : {}),
        ...dateRangeFilters,
    }
};

const getTimePeriodFilterWithProperFilters = (timePeriod: TimePeriod | undefined, searchParams: URLSearchParams): Omit<StatsFiltersType, 'contractor' | 'creator'> => {
    switch (timePeriod) {
        case 'single-month':
            return buildSingleMonthFilter(searchParams);
        case 'month-range':
            return buildMonthRangeFilter(searchParams);
        case 'year':
            return buildYearFilter(searchParams);
        case 'half-year':
            return buildHalfYearFilter(searchParams);
        case 'quarter':
            return buildQuarterFilter(searchParams);
        default:
            return TIME_PERIOD_OPTIONS['single-month'].defaultStats;
    }
}

const buildSingleMonthFilter = (searchParams: URLSearchParams): SingleMonthYearFilter => {
    const month = searchParams.get('month');
    const year = searchParams.get('year');

    const defaultSingleMonthStats = TIME_PERIOD_OPTIONS['single-month'].defaultStats as SingleMonthYearFilter;

    return {
        timePeriodSelector: 'single-month',
        singleMonthYear: {
            month: month ? Number(month) : defaultSingleMonthStats.singleMonthYear.month,
            year: year ? Number(year) : defaultSingleMonthStats.singleMonthYear.year,
        }
    }
}

const buildMonthRangeFilter = (serachParams: URLSearchParams): MonthYearRangeFilter => {
    const fromMonth = serachParams.get('fromMonth');
    const fromYear = serachParams.get('fromYear');
    const toMonth = serachParams.get('toMonth');
    const toYear = serachParams.get('toYear');

    const defaultMonthRangeStats = TIME_PERIOD_OPTIONS['month-range'].defaultStats as MonthYearRangeFilter;

    return {
        timePeriodSelector: 'month-range',
        monthYearRange: {
            fromMonth: fromMonth ? Number(fromMonth) : defaultMonthRangeStats.monthYearRange.fromMonth,
            fromYear: fromYear ? Number(fromYear) : defaultMonthRangeStats.monthYearRange.fromYear,
            toMonth: toMonth ? Number(toMonth) : defaultMonthRangeStats.monthYearRange.toMonth,
            toYear: toYear ? Number(toYear) : defaultMonthRangeStats.monthYearRange.toYear,
        },
    }
}

const buildQuarterFilter = (searchParams: URLSearchParams): QuarterFilter => {
    const quarter = searchParams.get('quarter');
    const year = searchParams.get('year');

    const defaultQuarterStats = TIME_PERIOD_OPTIONS['quarter'].defaultStats as QuarterFilter;

    return {
        timePeriodSelector: 'quarter',
        quarter: {
            quarter: quarter ? Number(quarter) : defaultQuarterStats.quarter.quarter,
            year: year ? Number(year) : defaultQuarterStats.quarter.year,
        }
    }
}

const buildHalfYearFilter = (searchParams: URLSearchParams): HalfYearFilter => {
    const halfYear = searchParams.get('halfYear');
    const year = searchParams.get('year');

    const defaultHalfYearStats = TIME_PERIOD_OPTIONS['half-year'].defaultStats as HalfYearFilter;

    return {
        timePeriodSelector: 'half-year',
        halfYear: {
            halfYear: halfYear ? Number(halfYear) : defaultHalfYearStats.halfYear.halfYear,
            year: year ? Number(year) : defaultHalfYearStats.halfYear.year,
        }
    }
}

const buildYearFilter = (searchParams: URLSearchParams): YearFilter => {
    const year = searchParams.get('year');

    const defaultYearStats = TIME_PERIOD_OPTIONS['year'].defaultStats as YearFilter;

    return {
        timePeriodSelector: 'year',
        yearFilter: {
            year: year ? Number(year) : defaultYearStats.yearFilter.year,
        }
    }
}
